import { resizeObservers } from '../utils/resizeObservers';
var hasActiveObservations = function () {
    return resizeObservers.some(function (ro) { return ro.activeTargets.length > 0; });
};
export { hasActiveObservations };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@juggle/resize-observer/lib/algorithms/hasActiveObservations.js
// module id = null
// module chunks = 